import React from "react";
import s from "./index.module.scss";
import DoorFeatures from "./DoorFeatures";
import TechnicalDocuments from "./TechnicalDocuments";
import SolidCore from "containers/ProductDetails/components/AdditionalInfo/SolidCore";

const AdditionalInfo = props => {
    const { product_details } = props.product;

    const productDetailSections = product_details.map(({ type, fields }) => {
        switch (type) {
            case 'banner_solid-core':
                return <SolidCore key={type} fields={fields} />
                break;
            case 'door_features':
                return <DoorFeatures key={type} fields={fields} />
                break;
            case 'technical_documents':
                return <TechnicalDocuments key={type} fields={fields} />
                break;
            default:
                return null;
        }
    }
  );

    return (
        <div className={s.AdditionalInfo}>
            {productDetailSections}
        </div>
    );
};

export default AdditionalInfo;
